import 'babel-polyfill'
// import io from 'socket.io-client'
import feathers from 'feathers/client'
import axios from 'axios'
import hooks from 'feathers-hooks'
// import socketio from 'feathers-socketio/client'
import rest from 'feathers-rest/client'
// import localstorage from 'feathers-localstorage'
import auth from 'feathers-authentication-client'
import Vue from 'vue'

const host = Vue.$backendBaseURL

const app = feathers()
  // .configure(socketio(socket))
  .configure(rest(host).axios(axios))
  .configure(hooks())
  .configure(auth({ storage: window.localStorage, path: '/authenticate' }))

// socket.on('reconnect', () => { app.authenticate() })

export default app

export const Orgs = app.service('orgs')
export const Campaigns = app.service('orgs/:orgId/campaigns')
export const Files = app.service('orgs/:orgId/files')
export const Voice = app.service('voices')
export const Peers = app.service('peers')
export const Headers = app.service('orgs/:orgId/files/:fileId/headers')
export const SubscriberDb = app.service('orgs/:orgId/subscriber_db')
export const Audio = app.service('orgs/:orgId/files/:fileId')
export const CampaignStatus = app.service('orgs/:orgId/campaigns/:campaignId/status')
export const Variables = app.service('orgs/:orgId/subscriber_db/:subscriberDbId/variables')
export const ResetLink = app.service('users/:userId/resetlink')
export const Roles = app.service('roles')
export const Users = app.service('orgs/:orgId/users')



// WEBPACK FOOTER //
// ./src/feathers.js